
import Button from '../../../components/base/Button';

export default function ProductsSection() {
  const products = [
    {
      id: 1,
      name: '糯香小圆片熟茶',
      sales: '2.5w+',
      image: 'https://public.readdy.ai/ai/img_res/0a759b3b77167597ebd18aba5eba08c8.jpg',
      description: '糯香浓郁，口感醇厚，回甘持久'
    },
    {
      id: 2,
      name: '丑甜砖',
      sales: '4w+',
      image: 'https://readdy.ai/api/search-image?query=Premium%20Chinese%20tea%20brick%20with%20unique%20irregular%20shape%2C%20dark%20compressed%20tea%20leaves%2C%20traditional%20pu-erh%20tea%20brick%20photography%2C%20rustic%20yet%20elegant%20appearance%2C%20natural%20lighting%2C%20artisanal%20tea%20craftsmanship%2C%20sophisticated%20product%20styling%20on%20natural%20wood%20surface&width=400&height=400&seq=product-2&orientation=squarish',
      description: '外形朴实，内质甘甜，层次丰富'
    },
    {
      id: 3,
      name: '顺泰味（2008年）',
      sales: '珍藏版',
      image: 'https://readdy.ai/api/search-image?query=Vintage%202008%20aged%20pu-erh%20tea%20cake%2C%20premium%20aged%20Chinese%20tea%20with%20golden%20wrapper%2C%20luxury%20vintage%20tea%20product%20photography%2C%20rich%20patina%20and%20aged%20appearance%2C%20elegant%20presentation%2C%20traditional%20Chinese%20tea%20culture%2C%20sophisticated%20lighting%20and%20styling&width=400&height=400&seq=product-3&orientation=squarish',
      description: '2008年珍品，陈香醇厚，茶韵悠长'
    },
    {
      id: 4,
      name: '七星茶王六堡茶',
      sales: '获奖产品',
      image: 'https://readdy.ai/api/search-image?query=Award-winning%20Liu%20Bao%20tea%20with%20seven%20stars%20design%2C%20premium%20Chinese%20dark%20tea%20photography%2C%20elegant%20packaging%20with%20golden%20accents%2C%20luxury%20tea%20product%20styling%2C%20traditional%20craftsmanship%2C%20sophisticated%20presentation%20with%20medal%20or%20trophy%20elements&width=400&height=400&seq=product-4&orientation=squarish',
      description: '七星茶王奖获奖产品，品质卓越'
    }
  ];

  const handleViewAllProducts = () => {
    window.REACT_APP_NAVIGATE('/products');
  };

  return (
    <section className="py-16 bg-white" data-product-shop>
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            核心产品
          </h2>
          <p className="text-sm sm:text-lg text-gray-600">
            精选年份茶，每一款都是时间的馈赠
          </p>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 overflow-hidden focus-within:ring-2 focus-within:ring-[#cc9966]"
              data-product-shop
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="p-4 lg:p-6">
                <div className="flex justify-between items-start mb-2 lg:mb-3">
                  <h3 className="text-xs sm:text-sm lg:text-base font-bold text-[#663333] line-clamp-2">
                    {product.name}
                  </h3>
                  <div className="bg-[#cc9966] text-white text-xs px-2 py-1 rounded-full whitespace-nowrap ml-2">
                    {product.sales}
                  </div>
                </div>
                
                <p className="text-xs lg:text-sm text-gray-600 mb-3 lg:mb-4 line-clamp-2">
                  {product.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button 
            variant="secondary" 
            size="lg" 
            className="rounded-full text-sm sm:text-lg"
            onClick={handleViewAllProducts}
          >
            查看全部产品
          </Button>
        </div>
      </div>
    </section>
  );
}